import React from 'react';
import DragDropOptionList from '../../../Components/DragDropOptionList';

const MenuOptionsSettings = ({ edit, setEdit, t }) => (
  <div>
    <h4 className='form-lbl' style={{ color: 'var(--header-color)', marginTop: '20px' }}>{t.optionsHeading}</h4>
    <DragDropOptionList edit={edit} setEdit={setEdit} />

    <div className='form-item'>
      <button
        style={{ width: '125px', marginTop: '40px' }}
        className='add-btn'
        onClick={() => {
          setEdit(prev => ({
            ...prev,
            props: {
              ...prev.props,
              options: [...(prev.props.options || []), { value: ((prev.props.options || []).length > 0 ? (prev.props.options || [])[(prev.props.options || []).length - 1].value + 1 : 0), label: 'Option ' + (((prev.props.options || []).length > 0 ? (prev.props.options || [])[(prev.props.options || []).length - 1].value + 1 : 0)) }],
            },
          }));
        }}
      >
        <span>{t.addOption}</span>
      </button>
    </div>
  </div>
);

export default MenuOptionsSettings;
